export enum LocalStorageKeys {
  mobileAppData = 'mobileAppData',
  mobileAppInsets = 'mobileAppInsets',
  token = 'token',
  userData = 'userData',
}

export enum RNPayloadActions {
  qr_scan = 'qr_scan',
  store_update = 'store_update',
  camera = 'camera',
  add_connected_tag = 'add_connected_tag',
  set_status_bar_style = 'set_status_bar_style',
  logout = 'logout',
}

export enum StatusBarStyles {
  default = 'default',
  light_content = 'light-content',
  dark_content = 'dark-content',
}

export enum RouteNames {
  login = 'Login',
  orders = 'Orders',
  history = 'History',
  supportData = 'Support data',
  support = 'Support',
  home = 'Home',
  orderDetails = 'Order details',
  bagItemisation = 'Bag itemisation',
  orderPacking = 'Order packing',
  orderPackingOneBag = 'Bag packing',
  orderItemsDetails = 'Order items details',
  orderTagPackages = 'Order tag packages',
  orderReceivedBagsReview = 'Order received bags review',
  bagDetails = 'Bag details',
  bagItemsDetails = 'Bag items details',
  bagPackagesDetails = 'Bag packages details',
  bagItemisationReview = 'Bag itemisation review',
  addBagProblem = 'Add bag problem',
  itemisationProcessingTime = 'Processing time',
  debug = 'debug',
  driverList = 'Driver list',
  driverListShift = 'Driver list shift',
  supportOrderProblemList = 'Order problems',
  supportOrderProblemListPreselect = 'Order problems preselect',
  registration = 'Registration',
  registrationWelcome = 'Registration welcome',
  registrationData = 'Register',
  futureOrders = 'Future orders',
}

export enum OrderListTabs {
  current = 'current',
  history = 'history',
}

export enum MainMenuItems {
  home = 'Home',
  history = 'History',
  orders = 'Orders',
  support = 'Support',
  scan = 'Scan',
}

export enum FacilityOrderTime {
  today = 'today',
  tomorrow = 'tomorrow',
  future = 'future',
  past = 'past',
}

export enum BagIconColors {
  blue = 'blue',
  light_blue = 'light-blue',
  orange = 'orange',
  gray = 'gray',
  gray_dark = 'gray_dark',
  gray_light = 'gray_light',
  black = 'black',
}

export enum CardWrapperColors {
  light_green = 'light-green',
  light_blue = 'light-blue',
  light_gray = 'light-gray',
  light_orange = 'light-orange',
  no_border = 'no-border',
}

/****************************************************
 *
 * OLD enums
 *
 * ***************************************************/
export enum UsernameTypes {
  phone = 'phone',
  email = 'email',
}

export enum OrderStatuses {
  processing = 'processing',
  completed = 'completed',
  cancelled = 'cancelled',
  on_hold = 'on_hold',
  pending = 'pending',
  reprocessing = 'reprocessing',
  inspection = 'inspection',
  completed_unprocessed = 'completed_unprocessed',
}

export enum FacilityOrderStatuses {
  to_scan = 'to_scan',
  scanned = 'scanned',
  itemised = 'itemised',
  on_hold = 'on_hold',
  packed = 'packed',
  check_for_reply = 'check_for_reply',
  wait_for_reply = 'wait_for_reply',
}

export enum FacilityOrderDeliveryStatuses {
  to_be_delivered = 'to_be_delivered',
  in_delivery = 'in_delivery',
  delivered = 'delivered',
}

export enum FacilityOrderBagStatuses {
  to_scan = 'to_scan',
  scanned = 'scanned',
  itemised = 'itemised',
  picked_by_driver = 'picked_by_driver',
  on_hold = 'on_hold',
  packed = 'packed',
  added_by_facility = 'added_by_facility',
  delivered = 'delivered',
  canceled = 'canceled',
  check_for_reply = 'check_for_reply',
}

export enum FacilityOrderBagInfoStatuses {
  to_scan = 'to_scan',
  scanned = 'scanned',
  inspect = 'inspect',
  reprocess = 'reprocess',
  itemised = 'itemised',
  on_hold = 'on_hold',
}

export enum FacilityOrderPackageTypes {
  bag = 'bag',
  hanger = 'hanger',
}

export enum ReportedTypes {
  item = 'item',
  bag = 'bag',
  order = 'order',
}

export enum ReportOptionTypes {
  document = 'document',
  report = 'report',
}

export enum FacilityServicesClassMap {
  'Wash & Iron' = 'wash_iron',
  'Wash' = 'wash',
  'Separate Wash' = 'wash',
  'Mixed Wash' = 'wash',
  'Dry Cleaning' = 'dry_cleaning',
  'Clean & Iron' = 'dry_cleaning',
  'Ironing' = 'iron',
  'Iron Only' = 'iron',
  'Duvets & Bulky Items' = 'duvets',
  'Repairs' = 'repairs',
  'Unprocessed' = 'unprocessed',
  'Follow instructions' = 'follow_instructions',
  'Follow online instructions' = 'follow_instructions',
  'Reprocessing' = 'reprocessing',
  'Inspection' = 'inspection',
}

export enum FacilityServiceShortCodes {
  'wash_and_iron' = 'wash_and_iron',
  'clean_and_iron' = 'clean_and_iron',
  'wash' = 'wash',
  'mixed_wash' = 'mixed_wash',
  'separate_wash' = 'separate_wash',
  'dry_cleaning' = 'dry_cleaning',
  'ironing_only' = 'ironing_only',
  'ironing' = 'ironing',
  'iron_only' = 'iron_only',
  'duvets_and_bulky_items' = 'duvets_and_bulky_items',
  'duvets_bulky_items' = 'duvets_bulky_items',
  'follow_instructions' = 'follow_instructions',
  'other' = 'follow_instructions',
  'reprocessing' = 'reprocessing',
  'inspection' = 'inspection',
  'carpet_cleaning' = 'carpet_cleaning',
  'sneakers_cleaning' = 'sneakers_cleaning',
  'repairs' = 'repairs',
  'risk_assessment' = 'risk_assessment',
  'unprocessed' = 'unprocessed',
}

export enum FacilityServiceShortCodesIconMap {
  'wash_and_iron' = 'wash&iron',
  'wash' = 'wash',
  'dry_cleaning' = 'dry cleaning',
  'ironing' = 'iron',
  'duvets_and_bulky_items' = 'duvets',
  'duvets_bulky_items' = 'duvets',
  'follow_instructions' = 'follow instructions',
  'other' = 'follow instructions',
  'reprocessing' = 'reprocessing',
  'inspection' = 'inspection',
  'carpet_cleaning' = 'follow instructions',
  'repairs' = 'repairs',
}

export enum FacilityBagServicesIconMap {
  'Wash & Iron' = 'wash&iron',
  'Wash' = 'wash',
  'Separate Wash' = 'wash',
  'Mixed Wash' = 'wash',
  'Dry Cleaning' = 'dry cleaning',
  'Ironing' = 'iron',
  'Iron Only' = 'iron',
  'Duvets & Bulky Items' = 'duvets',
  'Follow instructions' = 'follow instructions',
  'Follow online instructions' = 'follow instructions',
  'Reprocessing' = 'reprocessing',
  'Inspection' = 'inspection',
}

export enum NotificationTypes {
  'success' = 'success',
  'warning' = 'warning',
  'info' = 'info',
  'danger' = 'danger',
}

export enum StoreMutations {
  logout = 'logout',
  showLoader = 'showLoader',
  hideLoader = 'hideLoader',
  setAppError = 'setAppError',
  resetAppError = 'resetAppError',
  setSupportNotification = 'setSupportNotification',
  resetSupportNotification = 'resetSupportNotification',
  addFacilityBagServices = 'addFacilityBagServices',
  resetFacilityBagServices = 'resetFacilityBagServices',
  addFacilityOrderBag = 'addFacilityOrderBag',
  resetFacilityOrderBag = 'resetFacilityOrderBag',
  showBagPreviewMode = 'showBagPreviewMode',
  hideBagPreviewMode = 'hideBagPreviewMode',
  addFacilityOrder = 'addFacilityOrder',
  setConnected = 'setConnected',
  setAnnotationImage = 'setAnnotationImage',
  updateAnnotationImage = 'updateAnnotationImage',
  addAnnotateImage = 'addAnnotateImage',
  resetAnnotationImage = 'resetAnnotationImage',
  setAlreadyScannedInBags = 'setAlreadyScannedInBags',
  removeAlreadyScannedInBags = 'removeAlreadyScannedInBags',
  addAlreadyScannedInBags = 'addAlreadyScannedInBags',
  resetAlreadyScannedInBags = 'resetAlreadyScannedInBags',
  addNotification = 'addNotification',
  clearNotifications = 'clearNotifications',
  hideNotification = 'hideNotification',
  setKeyboardHeight = 'setKeyboardHeight',
  setKeyboardShown = 'setKeyboardShown',
  setKeyboardHidden = 'setKeyboardHidden',
  resetPreviousRoute = 'resetPreviousRoute',
  setPreviousRoute = 'setPreviousRoute',
  setRegistrationQRCode = 'setRegistrationQRCode',
  setRegistrationFacility = 'setRegistrationFacility',
  setRegistrationData = 'setRegistrationData',
  setOrderListPreselect = 'setOrderListPreselect',
  setFacility = 'setFacility',
  setFacilityOrders = 'setFacilityOrders',
  disableHardwareBackButtonNavigation = 'disableHardwareBackButtonNavigation',
  enableHardwareBackButtonNavigation = 'enableHardwareBackButtonNavigation',
}

export enum StoreActions {
  onShellMessage = 'onShellMessage',
  updateFacilityOrders = 'updateFacilityOrders',
}

export enum ErrorNames {
  NavigationDuplicated = 'NavigationDuplicated',
  Error = 'Error',
}

export enum ProblemCodes {
  service_mismatch = 'service_mismatch',
  stained = 'stained',
  damaged_items = 'damaged_items',
  another_item_problem = 'another_item_problem',
  creased = 'creased',
  more_time = 'more_time',
  item_need_more_time = 'item_need_more_time',
  different_processing = 'different_processing',
  item_service_mismatch = 'item_service_mismatch',
  problem_with_bag = 'problem_with_bag',
  missing_instructions = 'missing_instructions',
  unprocessed_item = 'unprocessed_item',
  cannot_process_item = 'cannot_process_item',
  reprocessing_inspection = 'reprocessing_inspection',
  special_item = 'special_item',
}

export enum ResolveTypes {
  accepted = 'accepted',
  rejected = 'rejected',
}

export enum ItemPhotoTypes {
  before = 'before',
  after = 'after',
}

export enum SquareButtonTypes {
  increment,
  decrement,
  slot,
}

export enum ButtonTypes {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  confirm = 'confirm',
  dark = 'dark',
  darkOutline = 'dark-outline',
  secondary_thick = 'secondary-thick',
}

/*************************************
 * PROBLEM REPORTING
 *************************************/
export enum ProblemReportTypes {
  report = 'report',
  document = 'document',
}

export enum ProblemResolutionApiTypes {
  accepted = 'accepted',
  rejected = 'rejected',
}

export enum ProblemResolutionTypes {
  not_reported = 'not_reported',
  unresolved = 'unresolved',
  accepted = 'accepted',
  rejected = 'rejected',
}

export enum PopupTypes {
  warning = 'warning',
  warning_red = 'warning_red',
  question = 'question',
  info = 'info',
  no_image = 'no_image',
  on_hold = 'on_hold',
  not_allowed = 'not_allowed',
  check_replies = 'check_replies',
}

export enum StatusPopupTypes {
  success_blue = 'success_blue',
  success_green = 'success_green',
  on_hold = 'on_hold',
  error = 'error',
  no_image = 'no_image',
}

export enum BusEvents {
  camera_closed,
}

export enum BagProblemTypes {
  extra_time = 'extra_time',
  other = 'other',
  cant_process = 'cant_process',
}

export enum SlideModalHeaderTypes {
  close_only,
  back_only,
  normal,
}

export enum SupportCenterProblemStates {
  received = 'received',
  waiting = 'waiting',
  resolved = 'resolved',
}

export enum ProcessingTimeConfirmationType {
  normal,
  waiting,
}

export enum OrderProblemType {
  /* Confirmation */
  confirmed = 'confirmed',
  unconfirmed = 'unconfirmed',
  /* Waiting */
  unresolved = 'unresolved',
  /* Resolved */
  accepted = 'accepted',
  rejected = 'rejected',
}

export enum ProblemAffectedTypes {
  bag = 'bag',
  order = 'order',
  item = 'item',
}

export enum StationNotificationTypes {
  new_reply = 'new_reply',
  order = 'order',
  survey_notification = 'survey_notification',
  order_filter_applied = 'order_filter_applied',
  order_delayed = 'order_delayed',
  orders_delayed = 'orders_delayed',
  order_rescheduled = 'order_rescheduled',
}

export enum RegistrationContactType {
  email,
  phone,
}

export enum InsetDirection {
  top,
  bottom,
  left,
  right,
}

export enum DashboardListStateCode {
  scan = 'scan',
  itemise = 'itemise',
  pack = 'pack',
  wait = 'wait',
  check_reply = 'check_reply',
  packed = 'packed',
}

export enum DashboardSpecialOrderType {
  reprocess = 'reprocess',
  inspection = 'inspection',
  risk_assessment = 'risk_assessment',
  prioritised = 'prioritised',
  on_hold = 'on_hold',
  packed = 'packed',
}

export enum DateTimeFormat {
  long = 'dddd, D MMM [at] hA',
  short = 'ddd, D MMM, hA',
  support_confirmed_at = 'ddd, D MMM, hh:mm',
}

export enum StatusBadgeType {
  bag = 'bag',
  order = 'order',
}

export enum FutureOrdersTime {
  tomorrow,
  future,
}

export enum PackingStep {
  imageCollection,
  packData,
  review,
}

export enum AvailableLocale {
  en = 'en',
  fr = 'fr',
}

export enum FacilityProblemReason {
  air_drying = 'air_drying',
  bulky_items = 'bulky_items',
  stains = 'stains',
  stubborn_stains = 'stubborn_stains',
  delicate_item = 'delicate_item',
  repair = 'repair',
  other = 'other',
}

export enum SpecialItemProblemReason {
  delicate_item = 'delicate_item',
  bulky_items = 'bulky_items',
  repair = 'repair',
  item_not_available_in_app = 'item_not_available_in_app',
  high_value_item = 'high_value_item',
  oversized_item = 'oversized_item',
  other = 'other',
}

export default {
  RouteNames,
  UsernameTypes,
  FutureOrdersTime,
  ButtonTypes,
  FacilityOrderPackageTypes,
  FacilityOrderStatuses,
  FacilityServiceShortCodesIconMap,
  FacilityBagServicesIconMap,
  FacilityOrderBagStatuses,
  NotificationTypes,
  StoreMutations,
  StoreActions,
  ProblemResolutionTypes,
  ProblemCodes,
  ReportedTypes,
  OrderListTabs,
  SquareButtonTypes,
  MainMenuItems,
  FacilityOrderTime,
  BagIconColors,
  PopupTypes,
  SlideModalHeaderTypes,
  BagProblemTypes,
  StatusPopupTypes,
  SupportCenterProblemStates,
  ProcessingTimeConfirmationType,
  OrderProblemType,
  ProblemAffectedTypes,
  StationNotificationTypes,
  ProblemReportTypes,
  RegistrationContactType,
  InsetDirection,
  CardWrapperColors,
  DashboardListStateCode,
  DashboardSpecialOrderType,
  DateTimeFormat,
  StatusBadgeType,
  PackingStep,
};
